import type { HTMLAttributes, ReactNode } from 'react';

export type CardPadding = 'sm' | 'md' | 'lg';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  children: ReactNode;
}

const PADDING_CLASS: Record<CardPadding, string> = {
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

/**
 * 共通カード。投稿・気づき・処方箋など各種コンテンツのコンテナとして利用。
 */
export function Card({ padding = 'md', className = '', children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={`bg-white rounded-lg shadow border border-slate-200 ${PADDING_CLASS[padding]} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
